import { Location, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadComponent } from 'components/file-upload/file-upload.component';
import { ConfirmModalComponent } from 'components/modal/confirm-modal/confirm-modal.component';
import { ServiceFormActionsComponent } from 'components/service/service-form-actions/service-form-actions.component';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import { TopicInfoComponent } from 'components/topic-info/topic-info.component';
import { ApiService } from 'services/api.service';
import { ToastService } from 'services/toast.service';
import { ReaderCardByClientId, ResearchTopicByClientIdCard, ResearchTopicListItem } from 'types/client.interface';
import { BackofficeReadingRoomSubmissionCard } from 'types/service.interface';
import { formatDatetime } from 'util/date.utility';

export const TIME_FORMAT = 'HH:mm';

@Component({
  selector: 'app-visit-room-summary',
  standalone: true,
  imports: [
    TranslateModule,
    NgClass,
    NgbCollapse,
    ServiceFormActionsComponent,
    TopicInfoComponent,
    FileUploadComponent,
    TooltipComponent,
    ConfirmModalComponent
  ],
  templateUrl: './visit-room-summary.component.html',
  styleUrls: [
    '../visit-room-topic-form/visit-room-topic-form.component.scss',
    './visit-room-summary.component.scss',
    '../../../form/base-form.scss'
  ]
})
export class VisitRoomSummaryComponent implements OnInit {
  public readonly formatDate = formatDatetime;
  @Input() application!: BackofficeReadingRoomSubmissionCard;
  @Input() researchTopics!: any[];
  @Input() clientId!: string;
  @Input() readersCard?: ReaderCardByClientId;
  @Output() applicationUpdated = new EventEmitter<BackofficeReadingRoomSubmissionCard>();

  chosenTopics: string[] = [];
  researchTopicsCollapsed: boolean[] = [];
  isGeneralSectionCollapsed: boolean = false;
  isResearchSectionCollapsed: boolean = false;
  isDocumentsSectionCollapsed: boolean = false;
  isReadersInfoSectionCollapsed: boolean = false;
  isSubmitting: boolean = false;
  isOpenConfirmDeleteSubmission = false;

  constructor(
    private apiService: ApiService,
    private toastService: ToastService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.researchTopicsCollapsed = this.application.researchTopics?.map(() => true) || [];
  }

  goToStep(step: string): void {
    this.router.navigate([], {
      queryParams: { solis: step },
      queryParamsHandling: 'merge'
    });
  }

  formatTime(time: string | null | undefined): string {
    return time ? time.substring(0, TIME_FORMAT.length) : '-';
  }

  updateTopics(topic: ResearchTopicListItem): void {
    if (!this.chosenTopics.includes(topic.id!)) {
      this.chosenTopics.push(topic.id!);
    } else {
      this.chosenTopics = this.chosenTopics.filter((id) => id !== topic.id);
    }
  }

  submit(): void {
    this.isSubmitting = true;
    this.apiService.submitVisitRoomApplication(this.application.id!).subscribe(
      (data: BackofficeReadingRoomSubmissionCard) => {
        this.toastService.showSuccess('applicationSubmittedTitle', '', {
          shouldTranslate: true,
          delay: 0
        });
        window.scrollTo(0, 0);
        this.applicationUpdated.emit(data);
        this.application = data;
        this.isSubmitting = false;
        this.router.navigate(['pieteikums/' + this.application.id]);
      },
      (error: any) => {
        console.error(error);
        this.toastService.showFormValidationError();
        this.isSubmitting = false;
      }
    );
  }

  editReaderInfo(): void {
    this.router.navigate(['klients/' + this.application.client!.id], {
      queryParams: { activeItem: 'mans-profils' }
    });
  }

  back(): void {
    if (this.application.initializationStatus === 'InitializationDone') {
      this.location.back();
    } else {
      this.router.navigate([], {
        queryParams: { solis: 3 },
        queryParamsHandling: 'merge'
      });
    }
  }

  getResearchTopic(id: string): ResearchTopicByClientIdCard {
    return this.researchTopics.find((topic: ResearchTopicByClientIdCard) => topic.id === id) as ResearchTopicByClientIdCard;
  }

  onModalClose(): void {
    this.isOpenConfirmDeleteSubmission = false;
  }

  handleDeleteDraft() {
    this.isOpenConfirmDeleteSubmission = true;
  }

  deleteReadingRoomSubmission() {
    if (this.application?.id) {
      this.apiService.deleteReadingRoomSubmission(this.application?.id).subscribe(
        () => {
          this.router.navigate(['/lasitavas-apmeklejums']);
          this.toastService.showSuccess('applicationDraftDeleted', '', {
            shouldTranslate: true
          });
        },
        (error: any) => {
          console.error(error);
          this.toastService.showRequestError();
        }
      );
    }
  }
}
